// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3L1x8","validationTips":"StatementDescriptor_validationTips__3fCYk"};